module.exports = __webpack_public_path__ + "static/media/iconError.38fb1fc7.svg";